import styled from "styled-components";

export const LanguageContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 72px;
    flex-wrap: wrap;
    max-width: 500px;
`;

export const LanguageItem = styled.p`
    cursor: pointer;
    margin-right: 4px;
    margin-left: 4px;
    font-weight: ${ props => props.bold || 'normal'};
    background-color: var(--gray-bg);
    padding: 8px;
    border-radius: 4px;
    min-width: fit-content;
    margin: 4px;
`;
